import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Image from 'next/image';
import useMailingListSignup, { OnSubmitData } from 'hooks/useMailingListSignup';

export default function JoinDailyPolished(): React.ReactElement {
  const [isValid, setValid] = useState<boolean>(false);
  const onMailingListSignupSubmit = useMailingListSignup();
  const {
    register,
    resetField,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm<OnSubmitData>({ defaultValues: { referralSource: 'blog page' } });

  const onSubmit = async (data: OnSubmitData) => {
    const result = await onMailingListSignupSubmit(data);
    if (result.success) {
      resetField('emailAddress');
    } else {
      setError('emailAddress', result.error);
    }
  };

  const validateEmail = (email: string): void => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const result = regex.test(email);
    setValid(result);
  };

  return (
    <div className="bg-metal flex flex-col text-cloud sticky top-32 p-10">
      <div className="flex flex-row lg:flex-col justify-evenly md:justify-center">
        <h1 className="text-[36px] leading-[47px]">
          Subscribe to <br /> Daily Polished
        </h1>
      </div>
      <hr className="w-full my-6 lg:w-full lg:mt-36" />
      <p className="mt-1.5 text-sm lg:w-full text-left lg:text-base">
        Discover new beauty brands daily and stock up on the ones you love. Sign
        up to be the first to know.
      </p>
      <form className="mt-5" onSubmit={handleSubmit(onSubmit)}>
        <label className="relative">
          <input
            className={`border pl-3 py-3 w-full text-onyx focus:outline-none ${isValid &&
              'border-b-2 border-b-mint border-t-onyx border-r-onyx border-l-onyx'
              } ${errors.emailAddress ? 'border-coral' : 'border'}`}
            type="text"
            placeholder="Email"
            {...register('emailAddress', {
              required: 'Email is required',
              onChange: (e) => validateEmail(e.target.value),
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i,
                message: 'This field must contain a valid email.'
              }
            })}
          />
          {isValid && (
            <div className="absolute top-1 right-4">
              <Image
                alt="Success"
                src="/icons/check.svg"
                width={16}
                height={16}
              ></Image>
            </div>
          )}
          {errors.emailAddress && (
            <div className="absolute top-1 right-4">
              <Image
                alt="Error"
                src="/exclamation.svg"
                width={16}
                height={16}
              ></Image>
            </div>
          )}
        </label>{' '}
        {errors.emailAddress && (
          <span className="text-sm mt-3 text-coral flex gap-1 relative items-center">
            {errors.emailAddress.type === 'required' && (
              <>{errors.emailAddress.message}</>
            )}
            {errors.emailAddress.type === 'pattern' && (
              <>{errors.emailAddress.message}</>
            )}
            {errors.emailAddress.type === 'api' && (
              <>{errors.emailAddress.message}</>
            )}
          </span>
        )}
        <button className="border border-cloud text-center uppercase mt-5 w-full py-3 font-medium tracking-widest">
          Subscribe
        </button>
      </form>
    </div>
  );
}
